import { createSelector } from 'reselect'
import { emptyObj } from 'util/objects'
import { sortByKey } from 'util/arrays/sorting'
import selectBase from './selectBase'

export const selectFoldersById = createSelector(selectBase, base => base.byId)

export const selectFolders = createSelector(selectFoldersById, foldersById =>
  sortByKey(Object.values(foldersById), 'position')
)

export const selectChatFolders = createSelector(selectFolders, folders =>
  folders.filter(folder => folder.type === 'Chat::Filter')
)

export function selectFolderIdFromProps(_, props) {
  return props.folderId || null
}

export function makeSelectFolderById() {
  return createSelector(
    selectFoldersById,
    selectFolderIdFromProps,
    (foldersById, folderId) => {
      return foldersById[folderId] || emptyObj
    }
  )
}
